export default __webpack_public_path__ + "static/media/dreamscape_account_schools.852b592c.png";